<template>
  <div>
    <div class="form">
      <div class="form-img">
        <img src="../../assets/images/zufang.png" />
      </div>
      <div class="form-box">
        <div class="form-box-t">
          您房子的图片
          <small>上传清晰全面的房源图片更容易接到客户的来电哦</small>
        </div>
        <div class="form-box-c" v-if="refer=='wechat'">
          <upload @change="getPictures" />
        </div>
        <div class="form-box-c" v-if="refer=='qianfan'  || refer=='pc'">
          <upload @change="getPictures" />
        </div>
      </div>
      <div class="form-box">
        <div class="form-box-t">出租类型</div>
        <div class="form-box-c">
          <formtag :lists="configs['type']" @change="getType"></formtag>
        </div>
      </div>
      <div class="form-box">
        <div class="form-box-t">选择小区</div>
        <div class="form-box-c">
          <marea :lists="configs.area" @change="getXiaoqu" />
        </div>
      </div>
 

      <div class="form-box">
        <div class="form-box-t">户型</div>
        <div class="form-box-c">
          <huxingpicker
            @change="getHuxing"
            :lists="[configs['shi'],configs['ting'],configs['wei']]"
          ></huxingpicker>
        </div>
      </div>
      <div class="form-box">
        <div class="form-box-t">楼层</div>
        <div class="form-box-c">
          <loucengpicker @change="getLouceng" :lists="[configs['louceng1'],configs['louceng2']]"></loucengpicker>
        </div>
      </div>

      <div class="form-box">
        <div class="form-box-t">装修程度</div>
        <div class="form-box-c">
          <formtag @change="getZhuangxiu" :lists="configs['zhuangxiu']"></formtag>
        </div>
      </div>
      <van-row :gutter="15">
        <van-col :span="12">
          <div class="form-box">
            <div class="form-box-t">建筑面积</div>
            <div class="form-box-c">
              <div class="form-box-tag">
                <div class="form-input-flex">
                  <input type="number" class="form-input" v-model="formItem.mianji" />
                  <div class="unit">m²</div>
                </div>
              </div>
            </div>
          </div>
        </van-col>
        <van-col :span="12">
          <div class="form-box">
            <div class="form-box-t">出租价格(0为面议)</div>
            <div class="form-box-c">
              <div class="form-box-tag">
                <div class="form-input-flex">
                  <input type="number" class="form-input" v-model="formItem.price" />
                  <div class="unit">元/月</div>
                </div>
              </div>
            </div>
          </div>
        </van-col>
      </van-row>

      <div class="form-box">
        <div class="form-box-t">租金收款方式</div>
        <div class="form-box-c">
          <formtag @change="getPay" :lists="configs['shoukuan']"></formtag>
        </div>
      </div>

      <div class="form-box">
        <div class="form-box-t">您房子的配套</div>
        <div class="form-box-c">
          <van-checkbox-group v-model="formItem.peitao">
            <van-checkbox v-for="(item, index) in peitao" :key="index" :name="item">{{ item }}</van-checkbox>
          </van-checkbox-group>
        </div>
      </div>

      <div class="form-box">
        <div class="form-box-t">联系人</div>
        <div class="form-box-c">
          <div class="form-box-tag">
            <div class="form-input-float">
              <input type="text" v-model="formItem.username" />
            </div>
          </div>
        </div>
      </div>

      <div class="form-box">
        <div class="form-box-t">联系电话</div>
        <div class="form-box-c">
          <div class="form-box-tag">
            <div class="form-input-float">
              <input type="number" v-model="formItem.phone" />
            </div>
          </div>
        </div>
      </div>

      <div class="form-box">
        <div class="form-box-t">房源描述</div>
        <div class="form-box-c">
          <div class="form-box-tag">
            <div class="form-input-float">
              <textarea
                v-model="formItem.content"
                rows="4"
                placeholder="详细的描述房屋状况，可以帮你快速的出租房源（5-2000个字符）"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="form-box">
        <div class="form-box-t">
          <van-button type="info" block @click="post">发布</van-button>
        </div>
      </div>
    </div>
    <footbar></footbar>
  </div>
</template>

<script>
window.addEventListener(
  "message",
  function(event) {
    // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
    var loc = event.data;
    if (loc && loc.module == "locationPicker") {
      //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
      console.log("location", loc);
    }
  },
  false
);
var root = process.env.VUE_APP_API_URL;
import Formtag from "../commpents/tag";
import Selecttime from "../commpents/Selecttime";
import Ruzhu from "../commpents/ruzhu";
import Huxingpicker from "../commpents/huxingpicker";
import Loucengpicker from "../commpents/loucengpicker";
import Upload from "../commpents/upload";
import Footbar from "../commpents/footbar";
import District from "../commpents/district";
import Community from "../commpents/community";
import Wechat from "../commpents/wechat";
import Tencentmap from "../commpents/tencentmap";
import Marea from "../commpents/marea";
import {
  Checkbox,
  CheckboxGroup,
  Card,
  SubmitBar,
  Toast,
  Cell,
  CellGroup,
  Button,
  Tabbar,
  TabbarItem,
  Icon,
  Row,
  Col,
  Tag,
  IndexBar,
  IndexAnchor
} from "vant";

export default {
  components: {
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    Formtag,
    Selecttime,
    Ruzhu,
    Huxingpicker,
    Loucengpicker,
    Upload,
    Footbar,
    District,
    Community,
    Wechat,
    Tencentmap,
    Marea
  },

  data() {
    return {
      getInitUrl: root + "post/init",
      getPostUrl: root + "post/zufang",
      active: "home",
      isactive: false,
      refer: "",
      islogin: 0,

      peitao: [
        "电视机",
        "冰箱",
        "洗衣机",
        "空调",
        "热水器",
        "床",
        "暖气",
        "宽带",
        "衣柜",
        "天然气"
      ],
      configs: [],
      formItem: {
        id: 0,
        agent: 0,
        community: "",
        area: {},
        huxing: [],
        chaoxiang: "",
        louceng: [],
        mianji: "",
        zhuangxiu: "",
        map: {},
        type: "",
        pay: "",
        price: "",
        pictures: [],
        phone: "",
        username: "",
        price: "",
        title: "出租",
        peitao: [],
        zhuangxiu: "",
        content: ""
      }
    };
  },

  mounted() {
    window.scrollTo(0, 0);
    this.init();
  },

  methods: {
    init() {
      var self = this;
      $.ajax({
        url: self.getInitUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: {},
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          self.configs = reponseData.configs;
          self.formItem.phone = reponseData.mobile;
          self.formItem.username = reponseData.name;
          self.formItem.agent = reponseData.agent;
          self.refer = reponseData.refer;
          self.islogin = reponseData.islogin;
          console.log(reponseData);
          if (self.islogin == 0) {
            self.$router.push("/login");
          }
        },
        error: function() {
          self.$toast("system error");
        }
      });
    },
    getArea(value) {
      this.formItem.area = value;
    },
    getXiaoqu(value) {
      this.formItem.community = value;
    },
    getChaoxiang(value) {
      this.formItem.chaoxiang = value;
    },
    getLouceng(value) {
      this.formItem.louceng = value;
    },
    getMap(value) {
      this.formItem.map = value;
    },
    getHuxing(value) {
      this.formItem.huxing = value;
    },

    getType(value) {
      this.formItem.type = value;
    },
    getZhuangxiu(value) {
      this.formItem.zhuangxiu = value;
    },
    getPay(value) {
      this.formItem.pay = value;
    },

    getPictures(value) {
      this.formItem.pictures = value;
      console.log(value);
    },
    post() {
      if (this.isactive) {
        this.$toast("已经提交");
        return;
      }
      var self = this;
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: "数据提交中"
      });

      $.ajax({
        url: self.getPostUrl,
        timeout: 120000,
        dataType: "json",
        type: "post",
        data: self.formItem,
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          self.$toast.clear();
          if (reponseData.status == 1) {
            self.isactive = true;
           // self.$toast(reponseData.message);
            self.$router.push("/post/zhifu/" + reponseData.data[0]+'/zufang');
           // self.$router.push("/zufang/view/" + reponseData.data[0]);
          } else {
            self.$toast(reponseData.message);
            self.isactive = false;
          }
        },
        error: function(reponseData) {
          console.log(reponseData);
          self.$toast("system error");
        }
      });
    }
  }
};
</script>

<style scoped>
#mapPage {
  width: 100vw;
  height: 100vh;
  display: block;
}
.van-checkbox-group {
  display: flex;
  flex-flow: wrap;
  background-color: #f8f8f8;
  padding: 10px 0 10px 15px;
  border-radius: 4px;
}
.van-checkbox {
  width: 25%;
  margin: 5px 0;
}
</style>>



